/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_errors_unknown_title = /** @type {(inputs: {}) => string} */ () => {
	return `Neznámá chyba`
};

const da_errors_unknown_title = /** @type {(inputs: {}) => string} */ () => {
	return `Ukendt fejl`
};

const de_errors_unknown_title = /** @type {(inputs: {}) => string} */ () => {
	return `Unbekannter Fehler`
};

const en_errors_unknown_title = /** @type {(inputs: {}) => string} */ () => {
	return `Unknown error`
};

const es_errors_unknown_title = /** @type {(inputs: {}) => string} */ () => {
	return `Error desconocido`
};

const fr_errors_unknown_title = /** @type {(inputs: {}) => string} */ () => {
	return `Erreur inconnue`
};

const hu_errors_unknown_title = /** @type {(inputs: {}) => string} */ () => {
	return `Ismeretlen hiba`
};

const it_errors_unknown_title = /** @type {(inputs: {}) => string} */ () => {
	return `Errore sconosciuto`
};

const nl_errors_unknown_title = /** @type {(inputs: {}) => string} */ () => {
	return `Onbekende fout`
};

const pl_errors_unknown_title = /** @type {(inputs: {}) => string} */ () => {
	return `Nieznany błąd`
};

const pt_errors_unknown_title = /** @type {(inputs: {}) => string} */ () => {
	return `Erro desconhecido`
};

const sv_errors_unknown_title = /** @type {(inputs: {}) => string} */ () => {
	return `Okänt fel`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const errors_unknown_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.errors_unknown_title(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("errors_unknown_title", locale)
	if (locale === "cs") return cs_errors_unknown_title(inputs)
	if (locale === "da") return da_errors_unknown_title(inputs)
	if (locale === "de") return de_errors_unknown_title(inputs)
	if (locale === "en") return en_errors_unknown_title(inputs)
	if (locale === "es") return es_errors_unknown_title(inputs)
	if (locale === "fr") return fr_errors_unknown_title(inputs)
	if (locale === "hu") return hu_errors_unknown_title(inputs)
	if (locale === "it") return it_errors_unknown_title(inputs)
	if (locale === "nl") return nl_errors_unknown_title(inputs)
	if (locale === "pl") return pl_errors_unknown_title(inputs)
	if (locale === "pt") return pt_errors_unknown_title(inputs)
	return sv_errors_unknown_title(inputs)
};
export { errors_unknown_title as "errors.unknown.title" }